// extracted by mini-css-extract-plugin
module.exports = {"container":"back-button_container__3CHv1","svg-body":"back-button_svg-body__3yCTb"};